import { createSvgIcon } from '@mui/material/utils';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var JumpMenuIcon = createSvgIcon( /*#__PURE__*/_jsxs(_Fragment, {
  children: [/*#__PURE__*/_jsx("path", {
    d: "M5,14H15a1,1,0,0,0,0-2H5a1,1,0,0,0,0,2Zm0,4H15a1,1,0,0,0,0-2H5a1,1,0,0,0,0,2Zm0-8H9A1,1,0,0,0,9,8H5a1,1,0,0,0,0,2Z"
  }), /*#__PURE__*/_jsx("path", {
    d: "M12.43,10V9a2,2,0,0,1,2-2h2",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: "2"
  }), /*#__PURE__*/_jsx("path", {
    d: "M16.25,4.53l2.16,2.14a.47.47,0,0,1,0,.67L16.25,9.49a.47.47,0,0,1-.8-.34V4.86A.47.47,0,0,1,16.25,4.53Z"
  })]
}), 'JumpMenuIcon');